<template>
    <div class="list-box">
        <template v-if="list.length">
            <div class="item-box" v-for="(item, index) in list" :key="index">
                <van-image radius="2" width="10vw" height="10vw" fit="cover" :src="item.photo">
                    <template v-slot:error>加载失败</template>
                </van-image>
                <div class="right-box">
                    <div class="top-info">
                        <div>{{ item.userNo }}</div>
                        <div class="phone-box">
                            {{ item.mobile || "" }}
                        </div>
                    </div>
                    <div class="item-info">
                        <div class="item-lable">微信昵称：</div>
                        <div class="item-value">{{ item.nickName || "" }}</div>
                    </div>
                    <div class="item-info">
                        <div class="item-lable">添加健康管家时间：</div>
                        <div class="item-value">{{ item.assistantBindTime || "-" }}</div>
                    </div>
                </div>
            </div>
            <div class="pagination" v-if="page.total > page.pageSize">
                <van-pagination v-model="page.pageNo" :total-items="page.total" :items-per-page="page.pageSize"
                    @change="pageChange">
                    <template #prev-text>
                        <van-icon name="arrow-left" />
                    </template>
                    <template #next-text>
                        <van-icon name="arrow" />
                    </template>
                    <template #page="{ text }">{{ text }}</template>
                </van-pagination>
            </div>
        </template>
        <van-empty description="暂无数据" v-else />
    </div>
</template>

<script>
import { getCorrespondingList } from "@/api/home";
export default {
    name: "response-user",
    components: {},
    data() {
        return {
            list: [],
            page: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
            keyword: '',
        };
    },
    methods: {
        async getResponseUserList() {
            try {
                const {
                    data: { list, total },
                } = await getCorrespondingList({
                    ...this.page,
                    keyword: this.keyword,
                });
                this.list = list
                this.page.total = total
            } catch (error) {
                this.list = [];
                console.log(error);
            }
        },
        pageChange(pageNo) {
            this.page.pageNo = pageNo
            this.getResponseUserList()
        },
        setPageParams(keyword) {
            this.page.pageNo = 1
            this.page.pageSize = 20
            this.keyword = keyword
            this.getResponseUserList()
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getResponseUserList();
    },
    activated() { },
};
</script>
<style lang="scss" scoped>
.list-box {
    .item-box {
        background: #fff;
        border-radius: 4px;
        padding: 15px;
        display: flex;

        &+.item-box {
            margin-top: 15px;
        }

        .right-box {
            margin-left: 10px;
            flex: 1;

            .top-info {
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .phone-box {
                    font-weight: normal;
                }
            }

            .item-info {
                display: flex;
                align-items: center;
                margin-top: 12px;
                font-size: 14px;

                .item-lable {
                    color: #666666;
                }

                .item-value {
                    color: #333333;
                }
            }
        }


    }
}

.pagination {
    padding: 20px 0;
}
</style>
